import { Modal } from 'styles/blocks/modal';
import React from 'react';
import { Text, Bold } from 'styles/elements/text';

export function DuplicateSubmissionModal({ isOpen, onSelectCancel }) {
  return (
    <Modal
      header="You've already submitted this questionnaire"
      cancelButtonText="Close this"
      isOpen={isOpen}
      onSelectCancel={onSelectCancel}
    >
      <Text>Check your email for a confirmation of your submission.</Text>
    </Modal>
  );
}

export function SessionExpiryWarningModal({ isOpen, onSelectConfirm, onSelectCancel }) {
  return (
    <Modal
      header="You've been on this screen for over 25 minutes. Do you want to continue working on it?"
      confirmButtonText="Yes, continue with the questionnaire"
      isOpen={isOpen}
      onSelectConfirm={onSelectConfirm}
      cancelButtonText="Exit the questionnaire"
      onSelectCancel={onSelectCancel}
    />
  );
}

export function DemoNoticeModal({ isOpen, onSelectConfirm }) {
  return (
    <Modal
      header="Just a reminder: this site is for demonstration purposes only"
      confirmButtonText="Okay, I understand"
      isOpen={isOpen}
      onSelectConfirm={onSelectConfirm}
    >
      <Bold>If you are a patient, please do not use this site to contact your doctor.</Bold>
      <Text>To check whether your doctor offers the eConsult service, visit your surgery&apos;s website.</Text>
    </Modal>
  );
}

export function LeavingPageWarningModal({ isOpen, onSelectConfirm, onSelectCancel }) {
  return (
    <Modal
      header="Are you sure you want to leave this screen?"
      confirmButtonText="Continue with the questionnaire"
      isOpen={isOpen}
      onSelectConfirm={onSelectConfirm}
      cancelButtonText="Exit the questionnaire (my data will be lost)"
      onSelectCancel={onSelectCancel}
    >
      <Text>Your answers will be lost and we won&apos;t submit the questionnaire</Text>
    </Modal>
  );
}

export function ConsultationEndedModal({ isOpen, onSelectConfirm, onSelectCancel }) {
  return (
    <Modal
      header="You've already exited this questionnaire"
      confirmButtonText="I understand, take me back to the start of the questionnaire"
      cancelButtonText="Close this"
      isOpen={isOpen}
      onSelectConfirm={onSelectConfirm}
      onSelectCancel={onSelectCancel}
    >
      <Text>The specialist clinician hasn&apos;t been notified and won&apos;t contact you about this.</Text>
      <Text>If you exited your questionnaire because of an urgent problem or symptom, please seek medical care now.</Text>
    </Modal>
  );
}
